// React
import { useCallback } from 'react'

// Models
import { useStores } from 'models'

// Interfaces
import { INewsWebpageGetAllAttrs, INewsWebpageGetAttrs } from 'interfaces/webpage/news/news-view.interface'

const useNewsWebpage = () => {
  // Hook
  const {
    newsWebpage: {
      newsWebpage_isLoading,
      newsWebpage_news,
      newsWebpage_detail,
      newsWebpage_CLEAR_NEWS,
      newsWebpage_CLEAR_DETAIL,
      newsWebpage_fetch: newsWebpageFetch,
      newsWebpage_fetchDetail: newsWebpageFetchDetail,
    },
  } = useStores()

  /**
   * @description Fetch all news
   *
   * @param {INewsWebpageGetAllAttrs} payload
   *
   * @return {Promise<void>} Promise<void>
   */
  const newsWebpage_fetch = useCallback(
    async (payload: INewsWebpageGetAllAttrs): Promise<void> => {
      return new Promise((resolve, reject) => {
        newsWebpageFetch({
          body: { ...payload.body },
          requestConfig: { ...payload.requestConfig },
          onSuccess: resolve,
          onError: reject,
        })
      })
    },
    // eslint-disable-next-line
    [],
  )

  /**
   * @description Fetch news detail
   *
   * @param {INewsWebpageGetAttrs} payload
   *
   * @return {Promise<void>} Promise<void>
   */
  const newsWebpage_fetchDetail = useCallback(
    async (payload: INewsWebpageGetAttrs): Promise<void> => {
      return new Promise((resolve, reject) => {
        newsWebpageFetchDetail({
          params: { ...payload.params },
          requestConfig: { ...payload.requestConfig },
          onSuccess: resolve,
          onError: reject,
        })
      })
    },
    // eslint-disable-next-line
    [],
  )

  return {
    newsWebpage_isLoading,
    newsWebpage_news,
    newsWebpage_detail,
    newsWebpage_CLEAR_NEWS,
    newsWebpage_CLEAR_DETAIL,
    newsWebpage_fetch,
    newsWebpage_fetchDetail,
  }
}

export { useNewsWebpage }
